<div class="product-card" *ngIf="product">
    <!-- Image Container -->
    <div class="image-container">
        <img [src]="product.images.imagesUrl[0]" [alt]="product.name" class="product-image" />
        <app-button
            variant="hero"
            (onClick)="addToCart(product, 1)"
            *ngIf="!product.category?.includes('Buy Blocks') && !getProductQtyInCart(product.id)"
            [disabled]="isLoading"
            buttonClass="transition-transform"
            class="quick-add-btn"
        >
            <mat-icon
                aria-hidden="true"
                aria-label="cart icon"
                fontIcon="shopping_cart"
                class="material-icons-outlined cart-icon-small"
            ></mat-icon>
            {{ isLoading ? "Adding..." : "Quick Add" }}
        </app-button>

        <!-- Badges -->
        <div class="badges">
            <app-badge *ngIf="product.discountPercentage" class="badge-discount"
                >{{ product.discountPercentage }}% OFF</app-badge
            >
        </div>

        <!-- Favorite Button -->
        <app-button
            variant="ghost"
            size="icon"
            class="favorite-button"
            buttonClass="favorite-button"
            (onClick)="toogleFavorite(product)"
            *ngIf="!product.category.includes(productCategories.BuyBlocks)"
        >
            <mat-icon
                *ngIf="isInWishlist(product)"
                aria-hidden="true"
                aria-label="favorite icon"
                fontIcon="favorite"
                class="favorite-icon red"
            ></mat-icon>
            <mat-icon
                *ngIf="!isInWishlist(product)"
                aria-hidden="true"
                aria-label="favorite icon"
                fontIcon="favorite_border"
                class="favorite-icon"
            ></mat-icon>
        </app-button>

        <!-- Quick Add to Cart Overlay -->
        <div class="quick-add-overlay" (click)="onClickProduct(product.id)"></div>
    </div>

    <!-- Product Info -->
    <div class="product-info">
        <h3 class="product-name transition-colors">
            {{ product.name }}
        </h3>

        <!-- Rating -->
        <div class="rating-section">
            <div class="stars" *ngIf="product.averageRating">
                <mat-icon
                    *ngFor="let star of getStarsArray(); let i = index"
                    class="star"
                    [ngClass]="{ filled: i < getFilledStars() }"
                    aria-hidden="true"
                    aria-label="star icon"
                    fontIcon="star"
                ></mat-icon>
            </div>
            <span class="rating-text" *ngIf="product.averageRating">
                {{ product.averageRating }} ({{ product.reviews?.length }})
            </span>
        </div>

        <!-- Price -->
        <div class="price-section">
            <div class="price-group">
                <span *ngIf="product.discountedPrice; else noDiscount">
                    <!-- Case: Product has a discounted price -->
                    <span class="current-price"> ₹{{ formatPrice(product.discountedPrice) }} </span>
                    <span *ngIf="product.price" class="original-price"> ₹{{ formatPrice(product.price) }} </span>
                </span>

                <ng-template #noDiscount>
                    <span class="current-price"> ₹{{ formatPrice(product.price) }} </span>
                </ng-template>
            </div>

            <ng-container *ngIf="!product.category?.includes('Buy Blocks'); else customizeButton">
                <div *ngIf="getProductQtyInCart(product.id); else addProduct" class="quantity-add">
                    <button
                        class="decrement"
                        [disabled]="getProductQtyInCart(product.id) <= 0"
                        (click)="onclick(-1, product.id)"
                    >
                        -
                    </button>
                    <input
                        class="quantity"
                        type="number"
                        [value]="getProductQtyInCart(product.id)"
                        (input)="onInputChange($event, product.id)"
                        (blur)="onBlur($event, product.id)"
                    />
                    <button
                        class="increment"
                        [disabled]="getProductQtyInCart(product.id) >= 99"
                        (click)="onclick(1, product.id)"
                    >
                        +
                    </button>
                </div>
                <ng-template #addProduct>
                    <app-button
                        variant="outline"
                        size="icon"
                        buttonClass="product-card-cart-button"
                        (onClick)="addToCart(product, 1)"
                        [disabled]="isLoading"
                    >
                        <mat-icon
                            aria-hidden="true"
                            aria-label="cart icon"
                            fontIcon="shopping_cart"
                            class="material-icons-outlined cart-icon-small"
                        ></mat-icon>
                    </app-button>
                </ng-template>
            </ng-container>
            <ng-template #customizeButton>
                <app-button variant="hero" (onClick)="onCustomize(product.id)" [disabled]="isLoading">
                    {{ isLoading ? "Loading..." : "Customize" }}
                </app-button>
            </ng-template>
        </div>
    </div>
</div>
